/**
 * Main Performance Tracking Page - Step 3 of the workflow (Track)
 * Temporarily disabled - showing Coming Soon message
 */

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp } from 'lucide-react';

const PerformanceTrackingPage: React.FC = () => {
  // Coming Soon - Temporarily disabled
  return (
    <div className='container mx-auto p-6 space-y-6'>
      {/* Coming Soon Message */}
      <Card className='max-w-2xl mx-auto mt-20'>
        <CardHeader>
          <div className='flex items-center justify-center mb-4'>
            <div className='h-20 w-20 rounded-full bg-primary/10 flex items-center justify-center'>
              <TrendingUp className='h-10 w-10 text-primary' />
            </div>
          </div>
          <CardTitle className='text-center text-2xl'>Performance Dashboard</CardTitle>
        </CardHeader>
        <CardContent className='text-center space-y-4'>
          <Badge variant='secondary' className='text-sm'>
            Coming Soon
          </Badge>
          <p className='text-muted-foreground'>
            We&apos;re working on bringing you comprehensive performance analytics and insights.
            This feature will help you monitor recall completion rates, technician efficiency, and
            campaign effectiveness.
          </p>
          <div className='pt-4'>
            <p className='text-sm text-muted-foreground'>
              In the meantime, use the <strong>Route Tracker</strong> to monitor daily operations.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PerformanceTrackingPage;
